// src/plugins/fontawesome.js
import Vue from 'vue';

// Core de fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';

// Iconos sólidos (fas)
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

// Iconos de marcas (fab)
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// Componente Vue para usar íconos
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Agrega los iconos que vas a usar a la librería
library.add(faEdit, faTrashAlt, faWhatsapp);

// Registra el componente globalmente
Vue.component('font-awesome-icon', FontAwesomeIcon);
